import { render, staticRenderFns } from "./ordgetinfo.vue?vue&type=template&id=7d74853c"
import script from "./ordgetinfo.vue?vue&type=script&lang=js"
export * from "./ordgetinfo.vue?vue&type=script&lang=js"
import style0 from "./ordgetinfo.vue?vue&type=style&index=0&id=7d74853c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports